    // Production Mode ...
const url = 'https://cners.sn';

    // Developpement Mode ...
// const url = 'http://127.0.0.1:8000';

export { url }